import type { WithSpaceProps } from 'canoe';
import { Caption, css, Mode, styled, withSpace } from 'canoe';
import React, { ReactNode } from 'react';

const GroupContainer = styled.div<WithSpaceProps>`
  ${({ theme }) => css`
    margin-bottom: ${theme.spaces.xs};
    position: relative;

    ${withSpace}
  `}
`;

const GroupLabel = styled(Caption)<{ mode?: Mode }>`
  ${({ theme, mode }) => css`
    margin-bottom: ${theme.spaces.xxs};
    color: ${theme.colors.OnyxGrayL20};
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    user-select: none;

    ${mode === 'Dark' &&
    css`
      color: ${theme.colors.GlitterGrayL30};
    `}
  `}
`;

export interface ValueGroupProps extends WithSpaceProps {
  id?: string;
  label?: string;
  mode?: Mode;
  children: ReactNode;
  'data-cy'?: string;
}

export const ValueGroup = ({
  id,
  label,
  mode,
  children,
  'data-cy': dataCy,
  ...rest
}: ValueGroupProps) => (
  <GroupContainer id={id} data-cy={dataCy} {...rest}>
    {!!label && <GroupLabel mode={mode}>{label}</GroupLabel>}
    {children}
  </GroupContainer>
);

export default ValueGroup;
